
import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { REFRESH_TOKEN, ACCESS_TOKEN, EMAIL } from "../components/constants";
import { useNavigate } from "react-router-dom";
import { api } from "./api";
import Loading from "../components/loading";
import { toast } from "react-toastify";

const Authorized = ({ children, isAuthenticated, setIsAuthenticated }) => {
    const navigate = useNavigate();

    const refreshAuthToken = async () => {
        const refreshToken = localStorage.getItem(REFRESH_TOKEN);
        const email = localStorage.getItem(EMAIL);
        if (!refreshToken) {
            throw new Error("No refresh token found");
        }

        try {
            const response = await api.post("/api/auth/refresh-token", { email, refreshToken });
            if (response.status === 200) {
                localStorage.setItem(ACCESS_TOKEN, response.data.access);
                return response.data.access;
            } else {
                throw new Error("Failed to refresh token");
            }
        } catch (error) {
            console.error("Error refreshing token:", error);
            throw error;
        }
    };

    const auths = async () => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        if (!token) {
            toast.error("No access token found. Please log in.");
            navigate("/login");
            return;
        }

        try {
            const decoded = jwtDecode(token);
            const currentTime = Date.now() / 1000;

            if (decoded.user.trim() !== "ADMIN") {
                toast.error("Unauthorized access. Redirecting...");
                navigate("/unauthorized");
                return;
            }

            if (decoded.exp < currentTime) {
                toast.info("Access token expired. Attempting to refresh...");
                console.log("Access token expired. Attempting to refresh...");
                const newToken = await refreshAuthToken();
                jwtDecode(newToken);
            }

        } catch (error) {
            console.error("Authentication error:", error);
            navigate("/login");
        }
    };
    useEffect(() => {
        let isMounted = true;
        const checkAuth = async () => {
            try {
                await auths();
                if (isMounted) {
                    setIsAuthenticated(true);

                }
            } catch {
                if (isMounted) {
                    setIsAuthenticated(false);
                }
            }
        };
        checkAuth();

        return () => {
            isMounted = false;

        };
    }, []);



    if (isAuthenticated === null) {
        return <Loading />;
    }

    return isAuthenticated
        ? children
        : null
};

export default Authorized;
